import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  displayName: PropTypes.node,
  value: PropTypes.string,
});
